import React, {memo, useEffect, useState, useRef} from 'react';
import theme from './style';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import PeopleAltOutlinedIcon from '@material-ui/icons/PeopleAltOutlined';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import SubjectOutlinedIcon from '@material-ui/icons/SubjectOutlined';
import ScheduleOutlinedIcon from '@material-ui/icons/ScheduleOutlined';
import KeyboardArrowDownOutlinedIcon from '@material-ui/icons/KeyboardArrowDownOutlined';
import CodeIcon from '@material-ui/icons/Code';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import {BorderButton,} from '../../components/buttons'
import {BorderSelect,} from '../../components/inputs'
import {Grid} from '@material-ui/core';
import translate from '../../misc/applyTranslation';
import {fetchFilesList, fetchFileData, uploadFile, setSelectedXML} from '../../redux/actions/files';
import {Markup} from 'interweave';
import {useConfig} from "../../context/configContext";
import moment from "moment";
import FilesTableRow from "../../components/FilesTableRow";

const FileView = (props) => {
  const config = useConfig();
  const classes = theme(config);
  const fileInputRef = useRef(null);
  const [modalOpen, setModalOpen] = useState(null);
  const [accordionOpen, setAccordionOpen] = useState(false)
  const [copied, setCopied] = useState(false);
  const {
    fetchFilesList,
    fetchFileData,
    uploadFile,
    access_token,
    refresh_token,
    fileList,
    fileData,
    selectedXML,
    setSelectedXML
  } = props;

  const fileError = fileData?.events?.groups.some(item => item.entity === "file");

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileUpload = (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile) {
      const formdata = new FormData();
      formdata.append("file", selectedFile, selectedFile.name);
      uploadFile({
        access_token,
        refresh_token,
        formdata,
      })
      e.target.value = "";
    }
  }
  useEffect(() => {
    fetchFilesList({
      access_token,
      refresh_token,
    })
    // eslint-disable-next-line
  }, [])
  useEffect(() => {
    if (selectedXML) {
      fetchFileData({
        access_token,
        refresh_token,
        id: selectedXML
      })
    }
    // eslint-disable-next-line
  }, [selectedXML]);
  const formatXML = () => {
    let data = JSON.parse(JSON.stringify(fileData))
    data = data.replace(/\|S\|(.+)/g, '<p class="upload_log_success">$1</p>')
    data = data.replace(/\|E\|(.+)/g, '<p class="upload_log_error">$1</p>')
    data = data.replace(/\|L\|(.+)/g, '<p class="upload_log_log">$1</p>')
    data = data.replace(/\|SUMMARY\|([\s\S]+)/, '<pre class="upload_log_summary">$1</pre>')
    return data;
  };

  const formatTechincalInfo = () => {
    let result = "";
    const entries = fileData.technical.entries;

    for (let i = 0; i < entries.length; i++) {
      result += `<div style="color: rgb(136, 136, 136); font-size: 13px"><span>[${moment(entries[i].timestamp).format("YYYY-MM-DD hh:mm:ss")}]&nbsp;</span><span>${entries[i].message}</span></div>`;
    }

    return result;
  }


  const copyList = () => {
    if (modalOpen === null) {
      return;
    }

    const group = fileData.events.groups[modalOpen];

    const text = group.examples
      .map((e) => {
        if (group.entity === "invoices") {
          return `INV-${e.identifier}`;
        }

        return e.detail
          ? `${e.identifier}\t${e.detail}`
          : e.identifier;
      })
      .join("\n");

    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);

      setTimeout(() => {
        setCopied(false);
      }, 1500);
    }).catch(() => {
    });
  };

  return (
    <div className={classes.pageWrapper}>
      <Grid container className={classes.topBar}>
        <Grid item xs={6}>
          <div className={classes.titleWrapper}>
            <h1>{translate('files', 'file_upload_panel_title')}</h1>
          </div>
        </Grid>
        <Grid item xs={6} className={classes.inputWrapper}>
          <BorderSelect
            selected={selectedXML}
            items={fileList}
            onChange={(e) => {
              setSelectedXML(e)
            }}
          />
          <input type="file" id="filehandler" ref={fileInputRef} style={{display: "none"}} onChange={handleFileUpload}/>
          <BorderButton onClick={handleButtonClick} text={translate('files', 'file_upload_panel_title')}/>
        </Grid>
      </Grid>

      {selectedXML !== 0 &&
        <>
          {fileError &&
            <div className={classes.alertBox}>
              <ReportProblemOutlinedIcon className={classes.alertIcon}/>
              <div className={classes.alertBoxTextWrapper}>
                <strong>{translate("files", "file_upload_warning_title")}</strong>
                <p>{(fileData.events?.groups.length > 0 && fileData.events?.groups[0].code) ? translate("files", `${fileData.events?.groups[0].code}_title`):  translate("files", "file_upload_warning_text_1")}</p>
                <p>{(fileData.events?.groups.length > 0 && fileData.events?.groups[0].description) ? translate("files", `${fileData.events?.groups[0].code}_description`):  translate("files", "file_upload_warning_text_2")}</p>
              </div>
            </div>
          }

          <div className={classes.cardsGrid}>
            <div className={classes.statCard}>
              <div className={classes.statCardHeader}>
                <div className={`${classes.statCardIcon} ${classes.icBlue}`}>
                  <PeopleAltOutlinedIcon/>
                </div>
                <h3>{translate("files", "card_title_customers")}</h3>
              </div>
              <div className={classes.statRow}>
                <span>{translate("files", "card_label_read")}</span>
                <span>{fileData?.cards?.customers?.read}</span>
              </div>
              <div className={classes.statRow}>
                <span>{translate("files", "card_label_imported")}</span>
                <span className={classes.valGreen}>{fileData?.cards?.customers?.imported}</span>
              </div>
              <div className={classes.statRow}>
                <span>{translate("files", "card_label_skipped")}</span>
                <span>{fileData?.cards?.customers?.skipped}</span>
              </div>
              <div className={classes.statRow}>
                <span>{translate("files", "card_label_events")}</span>
                <span className={classes.valRed}>{fileData?.cards?.customers?.events}</span>
              </div>
            </div>
            <div className={classes.statCard}>
              <div className={classes.statCardHeader}>
                <div className={`${classes.statCardIcon} ${classes.icGreen}`}>
                  <DescriptionOutlinedIcon/>
                </div>
                <h3>{translate("files", "card_title_invoices")}</h3>
              </div>
              <div className={classes.statRow}>
                <span>{translate("files", "card_label_read")}</span>
                <span>{fileData?.cards?.invoices?.read}</span>
              </div>
              <div className={classes.statRow}>
                <span>{translate("files", "card_label_imported")}</span>
                <span className={classes.valGreen}>{fileData?.cards?.invoices?.imported}</span>
              </div>
              <div className={classes.statRow}>
                <span>{translate("files", "card_label_skipped")}</span>
                <span>{fileData?.cards?.invoices?.skipped}</span>
              </div>
              <div className={classes.statRow}>
                <span>{translate("files", "card_label_events")}</span>
                <span className={classes.valRed}>{fileData?.cards?.invoices?.events}</span>
              </div>
            </div>
            <div className={classes.statCard}>
              <div className={classes.statCardHeader}>
                <div className={`${classes.statCardIcon} ${classes.icPurple}`}>
                  <SubjectOutlinedIcon/>
                </div>
                <h3>{translate("files", "card_title_total")}</h3>
              </div>
              <div className={classes.statRow}>
                <span>{translate("files", "card_label_read")}</span>
                <span>{fileData?.cards?.total?.read}</span>
              </div>
              <div className={classes.statRow}>
                <span>{translate("files", "card_label_imported")}</span>
                <span className="val-green">{fileData?.cards?.total?.imported}</span>
              </div>
              <div className={classes.statRow}>
                <span>{translate("files", "card_label_skipped")}</span>
                <span>{fileData?.cards?.total?.skipped}</span>
              </div>
              <div className={classes.statRow}>
                <span>{translate("files", "card_label_events")}</span>
                <span className="val-red">{fileData?.cards?.total?.events}</span>
              </div>
            </div>
            <div className={classes.statCard}>
              <div className={classes.statCardHeader}>
                <div className={`${classes.statCardIcon} ${classes.icOrange}`}>
                  <ScheduleOutlinedIcon/>
                </div>
                <h3>{translate("files", "card_title_import_info")}</h3>
              </div>
              <div className={classes.statRow}>
                <span>{translate("files", "card_label_start")}</span>
                <span>{moment(fileData?.import_info?.started_at).format("YYYY-MM-DD HH:mm:ss")}</span>
              </div>
              <div className={classes.statRow}>
                <span>{translate("files", "card_label_end")}</span>
                <span>{moment(fileData?.import_info?.finished_at).format("YYYY-MM-DD HH:mm:ss")}</span>
              </div>
              <div className={classes.statRow}>
                <span>{translate("files", "card_label_duration")}</span>
                <span>{fileData?.import_info?.duration !== "00:00:00" ? fileData?.import_info?.duration : "< 1 sek"}</span>
              </div>
            </div>
          </div>

          <div className={classes.eventsSection}>
            <div className={classes.eventsHeader}>
              <h2>{translate("files", "table_title")}</h2>
              {!fileError &&<span className={classes.eventsCount}>{fileData?.events?.total}</span>}
            </div>
            <p className={classes.eventsDesc}>
              {translate("files", "table_sub_title")}
            </p>
            <table className={classes.eventsTable}>
              <thead>
              <tr>
                <th>{translate("files", "table_column_title_event")}</th>
                <th>{translate("files", "table_column_title_category")}</th>
                <th>{translate("files", "table_column_title_quantity")}</th>
                <th>{translate("files", "table_column_title_example")}</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              {fileError ?
                <tr>
                  <td colSpan={5} className={classes.emptyState}>
                    No data to show
                  </td>
                </tr>
                :
                <FilesTableRow
                  items={fileData}
                  onBtnClick={setModalOpen}
                  modalOpen={modalOpen}
                  copyList={copyList}
                  copied={copied}
                />
              }
              </tbody>
            </table>
            {/* <button className={classes.showAllBtn}>
              Visa alla händelser (200)
              <KeyboardArrowDownOutlinedIcon/>
            </button>*/}
          </div>

          <div className={classes.accordion}>
            <div className={classes.accordionHeader} onClick={() => setAccordionOpen(!accordionOpen)} id="acc-header">
          <span className={classes.accordionHeaderLeft}>
           <CodeIcon/>
            {translate("files", "technical_info_title")}
          </span>
              {!accordionOpen ?
                <KeyboardArrowDownOutlinedIcon className={classes.accChevron} id="acc-chevron-down"/>
                :
                <KeyboardArrowUpIcon className={classes.accChevron} id="acc-chevron-up"/>
              }
            </div>
            {(accordionOpen && fileData) &&
              <div className={classes.accordionBody} id="acc-body">
                <Markup content={formatTechincalInfo()}/>
              </div>
            }
          </div>
        </>
      }
    </div>


    /*
      <React.Fragment>
          <Paper className={classes.fileInputContainer}>
            <div className='title'>{translate('files', 'file_upload_panel_title')}</div>
            <div className='text'>{translate('files', 'file_upload_panel_text')}</div>
            <input type='file' id='filehandler' className='fileInput' onChange={(e) => setFile(e.target.files[0])} />
            <div className='buttonContainer'>
              <BorderButton onClick={handleFileUpload} text={translate('files', 'file_upload_panel_title')} />
            </div>
          </Paper>
          <Paper className={classes.fileListContainer}>
            <div className='title'>{translate('files', 'file_report_panel_title')}</div>
            <div className='selectContainer'>
              <BorderSelect
                selected={selectedXML}
                items={fileList}
                onChange={(e) => { setSelectedXML(e) }}
              />
            </div>
            {fileData &&
              <div className={classes.fileDetailContainer}>
                <Markup content={formatXML(fileData)} />
              </div>
            }
          </Paper>
        </React.Fragment>*/
  )
}
FileView.propTypes = {}
const mapStateToProps = store => ({
  access_token: store.login.access_token,
  refresh_token: store.login.refresh_token,
  fileList: store.files.fileList,
  fileData: store.files.fileData,
  selectedXML: store.files.selectedXML

});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    fetchFilesList,
    fetchFileData,
    uploadFile,
    setSelectedXML
  }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(memo(FileView));
